import React from 'react';
import './invoice-status-chips.scss';
interface InvoiceStatusChipsProps {
  selectedStatus: string;
  statusChips: {
    label: string;
    value: string;
    onClick: () => void;
  }[];
  appliedFilters?: string[];
}
export const InvoiceStatusChips: React.FC<InvoiceStatusChipsProps> = ({
  selectedStatus,
  statusChips,
  appliedFilters,
}) => {
  return (
    <div className="invoice-status-chips">
      {appliedFilters?.map((chip) => (
        <div
          key={chip}
          className={`payment-status-chips-chip active`}
          onClick={() => {}}
        >
          {chip}
        </div>
      ))}
      {appliedFilters?.length > 0 && (
        <div className="chips-vertical-divider"></div>
      )}
      {statusChips.map((chip) => (
        <div
          key={chip.value}
          className={`invoice-status-chips-chip ${
            selectedStatus === chip.value ? 'active' : ''
          }`}
          onClick={chip.onClick}
        >
          {chip.label}
        </div>
      ))}
    </div>
  );
};
